import { observable, action } from 'mobx';
import agent from '../api/agent';

class generalStore {
    @observable Currencies = [
        { key: "AED", display: "AED - United Arab Emirates Dirham" },
        { key: "CNY", display: "CNY - Chinese Yuan" },
        { key: "EUR", display: "EUR - Euro" },
        { key: "GBP", display: "GBP - Great Britain Pound" },
        { key: "INR", display: "INR - Indian Rupee" },
        { key: "RUB", display: "RUB - Russian Ruble" },
        { key: "SGD", display: "SGD - Singapore Dollar" },
        { key: "USD", display: "USD - United States Dollar" },

    ]

    @observable dimensionConversionRatesToCM =
        {
            CENTIMETERS : 1,
            INCHES: 2.54,
            FEET: 30.48,
            METERS: 100
        }


    @observable dimensionConversionRatesFromCM = [
        {
            CENTIMETERS: 1,
            INCHES: 0.393701,
            FEET: 0.0328084,
            METERS: 0.01
        },

    ]


    @observable mediumChoices = []
    @observable baseChoices = []

    // @observable dimensionConversionRatesToCM =
    //     {
    //         1 : 1,
    //         3: 2.54,
    //         4: 30.48,
    //         2: 100
    //     }


    // @observable dimensionConversionRatesFromCM = [
    //     {
    //         1: 1,
    //         3: 0.393701,
    //         4: 0.0328084,
    //         2: 0.01
    //     },

    // ]
    @action getAllCurrenciesExchangeRate() {
        return agent.generalData.listOfCurrencies();
    }

    @action setMediumAndBaseChoices(mediumChoices, baseChoices){
        this.mediumChoices = mediumChoices;
        this.baseChoices = baseChoices;

    }
}

export default new generalStore();


// WEBPACK FOOTER //
// ./src/stores/generalStore.js